var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_405_12",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_405_12",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACGUlEQVR4nO3dO24TYRhG4QMiWQskC6SlpOCqbIbLMoANsARMZyQonCJCkIw93/j8l/eRposmnvd4LNkuDBEREREREetdA2+Br8BP4Ld8vNj2cttxCdwAv/BHny7CJfAZf+hpI9zgDzxthGvafNmZJsI7/FGPPV5usoTkG/6gfz/Dp7oTdvij3z0Ani/82yHuBHvwfwWAiSLYg/8vAEwSwR78vgAwQQR78IcCwOAR7MGXBICBI9iDLw0Ag0awBz8mAAwYwR782AAwWAR78FMCwEAR7MFPDQCDRLAHXxMABohgD742AHQewR68IgB0HMEevCoAdBrBHrwyAHQYwR68OgB0FsEefIsAsDyCzh58y0GWRNDZg289yEMRdPbg5xjkvgirPFl7ggY18axc6rH9AGaXALIEkCWALAFkCSBLAFkCyBJAlgCyBJC18FnQI/n/q58d5Q6QJYAsAWQJIEsAWQLIEkDWwvuArr7DrZY7QJYAsgSQJYAsAWQJIEsAWQvvA/J9QHgSQJYAsgSQJYAsAWQJIGvhfUC+DwhPAsgSQJYAsgSQJYAsAWQVAXYF5+jVj7UnqAjwveAcvVp97RUBPhWco1cf7AcAcEVfP2NVdeyBpwX7lXiPP8i5jzclyxW54PBSZI9yruPj7TU35YLDj7rt8Qfa6thzeOY3N/5dV8Br4Avt/cbYKcfu9lpeAc8Kd4qIiIiIiEn9Aeb9CbtRH0jGAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.aaf8b4c8214ad7e691667bc5b7b88d85.svg";
export { ForwardRef as ReactComponent };